import {
  TObjectShareRequest,
  TObjectShareResponse,
} from "../../../../services/api/instances/storageApi/types/service_types";

export const flattenPermissions = (
  permissions: TObjectShareResponse[],
): TObjectShareRequest[] =>
  permissions.flatMap(({ permission_pairs, ...rest }) => {
    if (!permission_pairs) return [];
    return permission_pairs
      .filter((pair) => pair.origin === "new")
      .map((pair) => ({
        ...rest,
        username: `${pair.username}@education_tools`,
      }));
  });
